module.exports = __webpack_public_path__ + "static/img/icon_arrow_r.ba8a2d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_arrow_r.svg
// module id = evt/
// module chunks = 156